import { combineReducers } from 'redux';

const masterInitialState = {
  list: null,
  loadStatus: 0,
  didLoadAll: false,
  query: {
    tab: 'all',
    keyword: '',
    size: 20,
  },
};

const detailInitialState = {
  loadStatus: 0,
  saveStatus: 0,
  payType: null,
  errorMessage: '',
  errCode: 0,
};

const storeDetailInitialState = {
  loadStatus: 0,
  data: null,
};

const trackDetailInitialState = {
  loadStatus: 0,
  data: null,
};
const createInitialState = {
  orderId: null,
  orderType: 0,
  extra: null,
  tips: {},
  key: null,
  addressId: null,
  warehouseError: null,
  groupId: null,
  selectedList: [],
  expectedCashCoupon: null,
  expectedCashList: [],
  giftCount: 0,
  giftList: [],
  cashList: [],
  cashId: null,
  postageList: [],
  postageId: null,
  idCardNo: '',
  idCardName: '',
  didAgree: true,
  payType: null,
  /* -1: 没库存, 0: 未提交 , 1: 提交中 , 2: 创建成功  */
  saveStatus: 0,
  preCreateStatus: 0,
  needsDeleteFromCart: false,
};

const skuDetailInitialState = {
  loadStatus: 0,
  data: null,
};

const skuCommentEditInitialState = {
  input: {
    isAnony: 1, //0:匿名，1:不匿名
    content: '',
  },
  saveStatus: 0,
  data: null,
};

const agentProductOrderDetailImitialState = {
  loadStatus: 0,
  data: null,
};

function createReducer(state = createInitialState, action) {
  switch (action.type) {
    case 'RESET_ORDER_INFO': {
      if (action.isOverseaOrder) {
        return state;
      }

      return createInitialState;
    }

    case 'PRE_CREATE_ORDER': {
      const { isOverseaOrder, needsDeleteFromCart } = action;

      if (isOverseaOrder) {
        return state;
      }

      return {
        ...state,
        preCreateStatus: 1,
        needsDeleteFromCart,
      };
    }

    case 'PRE_CREATE_ORDER_COMPLETION': {
      const {
        error,
        data,
        orderType,
        selectedList,
        giftList,
        groupId,
        recoverData,
      } = action;

      if (orderType === 6) {
        return state;
      }

      if (error) {
        return {
          ...state,
          preCreateStatus: 0,
        };
      }

      let res = {};
      let defaultCashId, defaultPostageId;
      let defaultAddressId = null;

      data.order && (res.extra = data.order);
      data.tips && (res.tips = data.tips);
      data.key && (res.key = data.key);

      if (data.coupon) {
        const {
          productCouponNum,
          cashCouponList,
          postageCouponList,
          cashCouponId,
          postageCouponId,
          expectedCashCoupon,
          expectedCashCouponList,
          restMoney,
        } = data.coupon;

        if (recoverData.cashId || recoverData.cashId === null) {
          defaultCashId = recoverData.cashId;
        } else {
          defaultCashId = cashCouponId ? cashCouponId : null;
        }

        if (
          (recoverData.postageId || recoverData.postageId === null) &&
          !recoverData.select
        ) {
          defaultPostageId = recoverData.postageId;
        } else {
          defaultPostageId = postageCouponId ? postageCouponId : null;
        }

        res.cashList = (cashCouponList || []).map(coupon => coupon.code);
        res.postageList = (postageCouponList || []).map(coupon => coupon.code);
        productCouponNum && (res.giftCount = productCouponNum);
        res.expectedCashList = (expectedCashCouponList || []).map(
          coupon => coupon.code
        );
        res.expectedCashCoupon = expectedCashCoupon
          ? {
              ...expectedCashCoupon,
              restMoney,
            }
          : null;
      }

      data.address && (defaultAddressId = data.address.aid);

      return {
        ...state,
        ...res,
        addressId: state.addressId ? state.addressId : defaultAddressId,
        cashId: defaultCashId,
        postageId: defaultPostageId,
        orderId: null,
        orderType,
        selectedList,
        giftList,
        groupId,
        warehouseError: null,
        preCreateStatus: 2,
      };
    }

    case 'CREATE_ORDER': {
      if (action.isOverseaOrder) {
        return state;
      }

      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'CREATE_ORDER_COMPLETION': {
      const { error, data, isOverseaOrder } = action;

      if (isOverseaOrder) {
        return state;
      }

      if (error) {
        if (error.code === -401) {
          return {
            ...state,
            saveStatus: -1,
            warehouseError: error.message,
          };
        }

        return {
          ...state,
          saveStatus: 0,
        };
      }
      return {
        ...state,
        saveStatus: 2,
        orderId: data.orderId,
      };
    }

    case 'PICK_ORDER_ADDRESS': {
      if (action.isOverseaOrder) {
        return state;
      }

      return {
        ...state,
        addressId: action.address.aid || null,
      };
    }

    case 'PICK_ORDER_CASH': {
      if (action.isOverseaOrder) {
        return state;
      }

      return {
        ...state,
        cashId: action.cashId || null,
      };
    }

    case 'PICK_ORDER_POSTAGE': {
      if (action.isOverseaOrder) {
        return state;
      }

      return {
        ...state,
        postageId: action.postageId || null,
      };
    }
    case 'SELECT_ORDER_PAY_TYPE': {
      const { orderId, payType, isOverseaOrder } = action;

      if (orderId || isOverseaOrder) {
        return state;
      }

      return {
        ...state,
        payType,
      };
    }

    default:
      return state;
  }
}
function overseaCreateReducer(state = createInitialState, action) {
  switch (action.type) {
    case 'RESET_ORDER_INFO': {
      if (!action.isOverseaOrder) {
        return state;
      }

      return createInitialState;
    }

    case 'PRE_CREATE_ORDER': {
      const { isOverseaOrder, needsDeleteFromCart } = action;

      if (!isOverseaOrder) {
        return state;
      }

      return {
        ...state,
        preCreateStatus: 1,
        needsDeleteFromCart,
      };
    }

    case 'PRE_CREATE_ORDER_COMPLETION': {
      const {
        error,
        data,
        orderType,
        selectedList,
        giftList,
        groupId,
        recoverData,
      } = action;

      if (orderType !== 6) {
        return state;
      }

      if (error) {
        return {
          ...state,
          preCreateStatus: 0,
        };
      }

      let res = {};
      let defaultCashId, defaultPostageId, defaultAddressId;

      data.order && (res.extra = data.order);
      data.tips && (res.tips = data.tips);
      data.key && (res.key = data.key);

      if (data.coupon) {
        const {
          productCouponNum,
          cashCouponList,
          postageCouponList,
          cashCouponId,
          postageCouponId,
          expectedCashCoupon,
          expectedCashCouponList,
          restMoney,
        } = data.coupon;

        if (recoverData.cashId || recoverData.cashId === null) {
          defaultCashId = recoverData.cashId;
        } else {
          defaultCashId = cashCouponId ? cashCouponId : null;
        }

        if (recoverData.postageId || recoverData.postageId === null) {
          defaultPostageId = recoverData.postageId;
        } else {
          defaultPostageId = postageCouponId ? postageCouponId : null;
        }

        res.cashList = (cashCouponList || []).map(coupon => coupon.code);
        res.postageList = (postageCouponList || []).map(coupon => coupon.code);
        productCouponNum && (res.giftCount = productCouponNum);
        res.expectedCashList = (expectedCashCouponList || []).map(
          coupon => coupon.code
        );
        res.expectedCashCoupon = expectedCashCoupon
          ? {
              ...expectedCashCoupon,
              restMoney,
            }
          : null;
      }

      if (data.idCard) {
        res.idCardNo = data.idCard.idCardNo;
        res.idCardName = data.idCard.idCardName;
      }

      data.address && (defaultAddressId = data.address.aid);

      return {
        ...state,
        ...res,
        addressId: state.addressId ? state.addressId : defaultAddressId,
        cashId: defaultCashId,
        postageId: defaultPostageId,
        orderId: null,
        orderType,
        selectedList,
        giftList,
        groupId,
        warehouseError: null,
        preCreateStatus: 2,
      };
    }
    case 'UPDATE_OVERSEA_ORDER_IDCARD': {
      return {
        ...state,
        idCardNo: action.idCardNo,
        idCardName: action.idCardName,
      };
    }
    case 'UPDATE_OVERSEA_ORDER_AGREEMENT': {
      return {
        ...state,
        didAgree: !state.didAgree,
      };
    }
    case 'CREATE_ORDER': {
      if (!action.isOverseaOrder) {
        return state;
      }

      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'CREATE_ORDER_COMPLETION': {
      const { error, data, isOverseaOrder } = action;

      if (!isOverseaOrder) {
        return state;
      }

      if (error) {
        if (error.code === -401) {
          return {
            ...state,
            saveStatus: -1,
            warehouseError: error.message,
          };
        }

        return {
          ...state,
          saveStatus: 0,
        };
      }
      return {
        ...state,
        saveStatus: 2,
        orderId: data.orderId,
      };
    }

    case 'PICK_ORDER_ADDRESS': {
      if (!action.isOverseaOrder) {
        return state;
      }

      return {
        ...state,
        addressId: action.address.aid || null,
      };
    }

    case 'PICK_ORDER_CASH': {
      if (!action.isOverseaOrder) {
        return state;
      }

      return {
        ...state,
        cashId: action.cashId || null,
      };
    }

    case 'PICK_ORDER_POSTAGE': {
      if (!action.isOverseaOrder) {
        return state;
      }

      return {
        ...state,
        postageId: action.postageId || null,
      };
    }

    case 'SELECT_ORDER_PAY_TYPE': {
      const { orderId, payType, isOverseaOrder } = action;

      if (orderId || !isOverseaOrder) {
        return state;
      }

      return {
        ...state,
        payType,
      };
    }

    default:
      return state;
  }
}

function ordersReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_ORDER_COMPLETION': {
      const { orderId, data, error } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        [orderId]: data,
      };
    }

    case 'LOAD_WEAPP_ORDER_LIST_COMPLETION':
    case 'LOAD_ORDER_LIST_COMPLETION':
    case 'LOAD_REFUND_ORDER_LIST_COMPLETION': {
      if (action.error) {
        return state;
      }

      const orders = action.list.reduce(
        (obj, order) => {
          const orderId = order.orderId;

          if (orderId) {
            obj[orderId] = { ...obj[orderId], ...order };
          }
          return obj;
        },
        { ...state }
      );

      return orders;
    }

    case 'REMOVE_ORDER_COMPLETION': {
      if (action.error) {
        return state;
      }

      const orders = { ...state };
      delete orders[action.orderId];

      return orders;
    }

    case 'CREATE_ORDER_COMPLETION':
    case 'CANCEL_ORDER_COMPLETION':
    case 'REFUND_ORDER_COMPLETION':
    case 'RECEIPT_ORDER_COMPLETION': {
      if (action.error) {
        return state;
      }

      const order = action.data;
      const orderId = order.orderId;
      const orders = { ...state };

      if (orderId) {
        orders[orderId] = { ...orders[orderId], ...order };
      }

      return orders;
    }

    case 'CREATE_REFUND_MONEY_COMPLETION': {
      const { error, orderId } = action;

      if (error) {
        return state;
      }

      let nextState = { ...state };

      delete nextState[orderId];

      return nextState;
    }

    case 'EDIT_ORDER_SKU_COMMENT_COMPLETION': {
      const { data, error } = action;

      if (error) {
        return state;
      }

      const { orderVo } = data;
      if (orderVo) {
        const { orderId } = orderVo;
        return {
          ...state,
          [orderId]: {
            ...state[orderId],
            ...(data && data.orderVo),
          },
        };
      } else {
        return state;
      }
    }

    default:
      return state;
  }
}

function storeDetailsReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_STORE_ORDER': {
      const { billNo } = action;

      return {
        ...storeDetailInitialState,
        loadStatus: 1,
      };
    }

    case 'LOAD_STORE_ORDER_COMPLETION': {
      const { billNo, error, data } = action;

      return {
        ...state,
        data: data,
        loadStatus: error ? 0 : 2,
      };
    }

    default:
      return state;
  }
}

function detailsReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_ORDER': {
      const { orderId } = action;

      return {
        ...state,
        [orderId]: {
          ...(state[orderId] || detailInitialState),
          loadStatus: 1,
        },
      };
    }

    case 'LOAD_ORDER_COMPLETION': {
      const { orderId, error } = action;

      return {
        ...state,
        [orderId]: {
          ...(state[orderId] || detailInitialState),
          loadStatus: error ? 0 : 2,
        },
      };
    }

    case 'CREATE_ORDER_COMPLETION': {
      const { error, data, payType } = action;

      if (error) {
        return state;
      }

      const orderId = data.orderId;

      return {
        ...state,
        [orderId]: {
          ...(state[orderId] || detailInitialState),
          payType,
        },
      };
    }

    case 'SELECT_ORDER_PAY_TYPE': {
      const { orderId, payType } = action;

      if (!orderId) {
        return state;
      }

      return {
        ...state,
        [orderId]: {
          ...(state[orderId] || detailInitialState),
          payType,
        },
      };
    }

    case 'CANCEL_ORDER':
    case 'REMOVE_ORDER':
    case 'REFUND_ORDER':
    case 'REFUND_COUPON_ORDER':
    case 'RECEIPT_ORDER':
    case 'PAY_ORDER_BY_WECHAT':
    case 'PAY_ORDER_BY_WALLET': {
      const { orderId } = action;

      return {
        ...state,
        [orderId]: {
          ...(state[orderId] || detailInitialState),
          saveStatus: 1,
        },
      };
    }

    case 'CANCEL_ORDER_COMPLETION':
    case 'REMOVE_ORDER_COMPLETION':
    case 'REFUND_ORDER_COMPLETION':
    case 'REFUND_COUPON_ORDER_COMPLETION':
    case 'RECEIPT_ORDER_COMPLETION':
    case 'PAY_ORDER_BY_WECHAT_COMPLETION':
    case 'PAY_ORDER_BY_WALLET_COMPLETION': {
      const { orderId, error } = action;

      return {
        ...state,
        [orderId]: {
          ...(state[orderId] || detailInitialState),
          saveStatus: error ? 0 : 2,
          errorMessage: error?.message || '',
          errCode: error?.code || 0,
        },
      };
    }

    default:
      return state;
  }
}

function masterReducer(state = masterInitialState, action) {
  switch (action.type) {
    case 'LOAD_WEAPP_ORDER_LIST':
    case 'LOAD_ORDER_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }

    case 'LOAD_WEAPP_ORDER_LIST_COMPLETION':
    case 'LOAD_ORDER_LIST_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      const list = action.list.map(order => order.orderId);

      return {
        ...state,
        loadStatus: 2,
        didLoadAll: list.length < state.query.size,
        list: state.list ? state.list.concat(list) : list,
      };
    }

    case 'CREATE_ORDER_COMPLETION': {
      if (action.error) {
        return state;
      }

      return {
        ...state,
        list: null,
        loadStatus: 0,
        loadedAll: false,
      };
    }

    case 'REMOVE_ORDER_COMPLETION': {
      const { error, orderId } = action;

      if (error) {
        return state;
      }
      if (!state.list) {
        return state;
      }

      let list = state.list.slice();
      const idx = list.findIndex(item => item === orderId);
      if (idx >= 0) {
        list.splice(idx, 1);
      }

      return {
        ...state,
        list,
      };
    }

    default:
      return state;
  }
}

function storeMasterReducer(state = masterInitialState, action) {
  switch (action.type) {
    case 'LOAD_STORE_ORDER_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }

    case 'LOAD_STORE_ORDER_LIST_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      const list = action.list.map(item => {
        item.amount = (item.amount / 100).toFixed(2);
        return item;
      });

      return {
        ...state,
        loadStatus: 2,
        didLoadAll: list.length < state.query.size,
        list: state.list ? state.list.concat(list) : list,
      };
    }

    default:
      return state;
  }
}

function trackDetailsReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_ORDER_TRACK': {
      const { orderId } = action;

      return {
        ...state,
        [orderId]: {
          ...(state[orderId] || trackDetailInitialState),
          loadStatus: 1,
        },
      };
    }

    case 'LOAD_ORDER_TRACK_COMPLETION': {
      const { orderId, data, error } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        [orderId]: {
          ...(state[orderId] || trackDetailInitialState),
          loadStatus: 2,
          data,
        },
      };
    }

    default:
      return state;
  }
}

function orderSkuDetailReducer(state = skuDetailInitialState, action) {
  switch (action.type) {
    case 'LOAD_ORDER_SKU': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_ORDER_SKU_COMPLETION': {
      const { error, data } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        data,
      };
    }

    default:
      return state;
  }
}

function orderSkusReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_ORDER_SKU_COMPLETION': {
      const { orderSkuId, data, error } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        [orderSkuId]: data && data.orderSku,
      };
    }

    case 'EDIT_ORDER_SKU_COMMENT_COMPLETION': {
      const { orderSkuId, data, error } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        [orderSkuId]: {
          ...state[orderSkuId],
          ...(data && data.orderSkuVo),
        },
      };
    }

    case 'LOAD_ORDER_COMPLETION': {
      const { data, error } = action;

      if (error) {
        return state;
      }

      const { orderSkuVos } = data;
      const skus = (orderSkuVos || []).reduce(
        (obj, sku) => {
          const orderSkuId = sku.orderSkuId;

          if (orderSkuId) {
            obj[orderSkuId] = sku;
          }
          return obj;
        },
        { ...state }
      );

      return skus;
    }

    case 'LOAD_WEAPP_ORDER_LIST_COMPLETION':
    case 'LOAD_ORDER_LIST_COMPLETION':
    case 'LOAD_REFUND_ORDER_LIST_COMPLETION': {
      if (action.error) {
        return state;
      }

      const skus = action.list.reduce(
        (obj, order) => {
          if (order.orderId) {
            const { orderSkuVos } = order;
            orderSkuVos.reduce(
              (skuObj, sku) => {
                const { orderSkuId } = sku;
                if (orderSkuId) {
                  obj[orderSkuId] = sku;
                }
                return obj;
              },
              { ...state }
            );
          }
          return obj;
        },
        { ...state }
      );

      return skus;
    }

    default:
      return state;
  }
}

function orderSkuCommentEditReducer(
  state = skuCommentEditInitialState,
  action
) {
  switch (action.type) {
    case 'SYNC_ORDER_SKU_COMMENT_EDIT_INPUT': {
      return {
        ...state,
        input: {
          ...(action.reset ? skuCommentEditInitialState.input : state.input),
          ...action.input,
        },
      };
    }

    case 'EDIT_ORDER_SKU_COMMENT': {
      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'EDIT_ORDER_SKU_COMMENT_COMPLETION': {
      const { error, data } = action;
      if (error) {
        return {
          ...state,
          saveStatus: 0,
        };
      }

      return {
        ...state,
        saveStatus: 2,
        data,
      };
    }

    default:
      return state;
  }
}

function agentProductOrderDetailReducer(
  state = agentProductOrderDetailImitialState,
  action
) {
  switch (action.type) {
    case 'LOAD_AGENT_PRODUCT_ORDER_DETAIL': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_AGENT_PRODUCT_ORDER_DETAIL_COMPLETION': {
      const { error, data } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        data,
      };
    }

    default:
      return state;
  }
}

export default combineReducers({
  create: createReducer,
  overseaCreate: overseaCreateReducer,
  orders: ordersReducer,
  details: detailsReducer,
  storeDetails: storeDetailsReducer,
  master: masterReducer,
  storeMaster: storeMasterReducer,
  trackDetails: trackDetailsReducer,
  orderSkuDetail: orderSkuDetailReducer,
  orderSkus: orderSkusReducer,
  orderSkuCommentEdit: orderSkuCommentEditReducer,
  agentProductOrderDetail: agentProductOrderDetailReducer,
});
